<div class="modal-historico">
  <h2 mat-dialog-title>Movimientos del Polígono</h2>
  <p class="subtitulo">Creaciones, actualizaciones, cierres y aperturas registrados para todas las bodegas y fechas de picking de este polígono.</p>

  <mat-dialog-content>
    <div class="filtro-fecha">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label><i class="fas fa-calendar-alt me-2"></i>Filtrar por Fecha Picking</mat-label>
        <input matInput type="date" [(ngModel)]="filtroFecha">
        <button *ngIf="filtroFecha" mat-icon-button matSuffix (click)="filtroFecha=''">
          <mat-icon>clear</mat-icon>
        </button>
      </mat-form-field>
    </div>

    <div *ngIf="historico.length === 0" class="text-center p-3">
      No hay movimientos registrados para este polígono.
    </div>

    <div *ngIf="historico.length > 0 && historicoFiltrado.length === 0" class="text-center p-3">
      No hay movimientos para la fecha de picking seleccionada.
    </div>

    <div *ngIf="historicoFiltrado.length > 0" class="table-container">
      <table mat-table [dataSource]="historicoFiltrado" class="w-100">

        <ng-container matColumnDef="FECHA_EVENTO">
          <th mat-header-cell *matHeaderCellDef>Fecha<br><small>del movimiento</small></th>
          <td mat-cell *matCellDef="let element">{{element.FECHA_EVENTO | date:'dd/MM/yyyy HH:mm'}}</td>
        </ng-container>

        <ng-container matColumnDef="USUARIO_EVENTO">
          <th mat-header-cell *matHeaderCellDef>Usuario<br><small>que ejecutó</small></th>
          <td mat-cell *matCellDef="let element">{{element.USUARIO_EVENTO || '-'}}</td>
        </ng-container>

        <ng-container matColumnDef="TIPO_EVENTO">
          <th mat-header-cell *matHeaderCellDef>Evento</th>
          <td mat-cell *matCellDef="let element">
            <span class="badge" [ngClass]="{'badge-success': element.TIPO_EVENTO === 'INSERT', 'badge-warning': element.TIPO_EVENTO === 'UPDATE', 'badge-danger': element.TIPO_EVENTO === 'DELETE'}">
              {{getEventoLabel(element.TIPO_EVENTO)}}
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="COD_BODEGA">
          <th mat-header-cell *matHeaderCellDef>Bodega</th>
          <td mat-cell *matCellDef="let element">
            <span class="badge bg-secondary">{{element.COD_BODEGA}}</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="TIPO_SERVICIO">
          <th mat-header-cell *matHeaderCellDef>Tipo<br><small>de cierre</small></th>
          <td mat-cell *matCellDef="let element">
            <span class="tipo-cierre" [class.tipo-cierre-servicio]="getTipoServicio(element)">
              {{getTipoServicioLabel(getTipoServicio(element))}}
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="FECHA_PICKING">
          <th mat-header-cell *matHeaderCellDef>Fecha<br><small>Picking</small></th>
          <td mat-cell *matCellDef="let element">{{element.FECHA_PICKING | date:'dd/MM/yyyy'}}</td>
        </ng-container>

        <ng-container matColumnDef="ESTADO_APERTURA">
          <th mat-header-cell *matHeaderCellDef>Estado<br><small>del polígono</small></th>
          <td mat-cell *matCellDef="let element">
            <span class="badge" [class.bg-danger]="element.ESTADO_APERTURA === 'C'" [class.bg-success]="element.ESTADO_APERTURA === 'A'">
              {{getEstadoLabel(element.ESTADO_APERTURA)}}
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="CIERRE">
          <th mat-header-cell *matHeaderCellDef>Cierre<br><small>Usuario / Fecha</small></th>
          <td mat-cell *matCellDef="let element">
            <div *ngIf="element.USUARIO_CIERRE">
              <div class="user-info">
                <i class="fas fa-user text-danger me-1"></i>
                <strong>{{element.USUARIO_CIERRE}}</strong>
              </div>
              <div class="date-info">
                <small class="text-muted">{{element.FECHA_CIERRE | date:'dd/MM/yyyy HH:mm'}}</small>
              </div>
            </div>
            <small *ngIf="!element.USUARIO_CIERRE">-</small>
          </td>
        </ng-container>

        <ng-container matColumnDef="APERTURA">
          <th mat-header-cell *matHeaderCellDef>Apertura<br><small>Usuario / Fecha</small></th>
          <td mat-cell *matCellDef="let element">
            <div *ngIf="element.USUARIO_APERTURA">
              <div class="user-info">
                <i class="fas fa-user text-success me-1"></i>
                <strong>{{element.USUARIO_APERTURA}}</strong>
              </div>
              <div class="date-info">
                <small class="text-muted">{{element.FECHA_APERTURA | date:'dd/MM/yyyy HH:mm'}}</small>
              </div>
            </div>
            <small *ngIf="!element.USUARIO_APERTURA">-</small>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button (click)="cerrar()">Cerrar</button>
  </mat-dialog-actions>
</div>
